export default "__VITE_ASSET__6530fce6__"